<template>
  <ElButton
    type="info"
    @click="showDialog()"
  >
    {{ title }}

    <ElDialog
      append-to-body
      :title="title | ucwords"
      top="25vh"
      :visible.sync="showForm"
    >
      <ElForm
        label-position="left"
        @submit.native.prevent
      >
        <el-select
          v-model="updateStatus"
        >
          <el-option
            v-for="item in items"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </ElForm>

      <span
        slot="footer"
        class="dialog-footer"
      >
        <ElButton
          class="margin-right-unit"
          type="text"
          @click="showForm = false"
        >
          Cancel
        </ElButton>

        <ElButton
          type="primary"
          :disabled="status === updateStatus"
          @click="changeStatus()"
        >
          Submit
        </ElButton>
      </span>
    </ElDialog>
  </ElButton>
</template>

<script>
import axios from '@/axios/axios'

export default {
  name: 'ChangeStatus',
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showForm: false,
      updateStatus: null,
      items: [
        { value: 'FREE', label: 'Free' },
        { value: 'EXPIRED', label: 'Expired' },
        { value: 'PAID', label: 'Paid' }
      ]
    }
  },
  computed: {
    title() {
      return 'CHANGE STATUS'
    },

    profile() {
      return this.user.profile
    },

    status() {
      return this.profile.status
    }
  },
  methods: {
    showDialog() {
      this.updateStatus = this.status
      this.showForm = true
    },

    changeStatus() {
      const data = {
        profileId: this.profile.id,
        status: this.updateStatus
      }

      axios.post('admin/change-status', data)
        .then(res => {
          const updateData = {
            id: this.user.id,
            status: this.updateStatus
          }

          this.$store.commit('updateRecruiterProfile', updateData)

          this.successNotification(res.data)

          this.showForm = false
        })
        .catch(axios.handleError)
    }
  }
}
</script>
